export default '4.22.2';
